import { getText } from 'src/ConsentManagement/TranslationService';

type DescriptionModel = {
  textTranslationKey?: string;
  innerContent?: Document;
};

export const Description = ({ textTranslationKey, innerContent }: DescriptionModel) => {
  const innerHtml = innerContent != null ? { __html: innerContent.body.innerHTML } : null;

  return (
    <div class="cc-description">
      <p class="cc-message-text" dangerouslySetInnerHTML={innerHtml}>
        {textTranslationKey != null ? getText(textTranslationKey) : null}
      </p>
    </div>
  );
};
